import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=02edbcb2&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02edbcb2')) {
      api.createRecord('02edbcb2', component.options)
    } else {
      api.reload('02edbcb2', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=02edbcb2&", function () {
      api.rerender('02edbcb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrP4BZsZwhER/JS/comp/stardisplay.vue"
export default component.exports